import React from 'react'
import './index.less'
import { globalData } from '../../common/config';

const Index = () => {
  return (
    <div className="card-banner">
      {
        (() => {
          if (globalData['productCode'] === 'P060090') {
            return <div className="card-banner-item-free"></div>
          } else if (globalData['productCode'] === 'P060091') {
            return <div className="card-banner-item-busi"></div>
          } else if (globalData['productCode'] === 'P060092') {
            return <div className="card-banner-item-new"></div>
          } else {
            return <div className="card-banner-item"></div>
          }
        })()
      }
      
    </div>
  )
}

export default Index;